import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';

interface IGetUserCommitteeDataTableStructureProps {
  rowActions?: DataTableRowActions;
}

export const getUserCommitteeDataTableStructure = ({ rowActions }: IGetUserCommitteeDataTableStructureProps): DynamicDataTable => {
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.userInfo.table.nom',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  return {
    singular: 'settings.userInfo.table.com',
    plural: 'settings.userInfo.table.coms',
    columns: [nameColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    searchableFields: ['nom', 'decretCreation', 'responsable', 'special'],
    rowActions,
  };
};
